module.exports = __webpack_public_path__ + "9788f41e/img/grid-web-icon.d0395d64.svg";